const anchorOffset = {
  anchors: document.querySelectorAll('.jsAnchorTag') as NodeListOf<HTMLElement>,

  init() {
    this.setOffset();
  },

  setOffset() {
    this.anchors.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();

        const targetId = item.getAttribute('href')?.substring(1);
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        const yOffset = -100;
        const y =
          targetElement.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({
          top: y,
          behavior: 'smooth',
        });
      });
    });
  },
};

export default anchorOffset;
